/* unplugin-vue-components disabled */import { render } from "./Explore.vue?vue&type=template&id=bbe43a9c"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__